import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CancelIcon from '@mui/icons-material/Cancel';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { RejectAprovalButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box'
import { BaseInputField } from '../style/textfield'
import { postData } from "../func/api";
import { useAuth } from "../contexts/AuthContext";
import { InputDialog } from "./input_dialog";

export default function ReportRejectApprovalDialog({ report_or_inspection_uuid, earthquake_uuid, type, report_uuid }) {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [note, setNote] = useState("");
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    // バリデーションスキーマを定義
    const validationSchema = yup.object().shape({
        note: yup
            .string()
            .max(1000, "最大1000文字です")
            .required("必須です"),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        trigger,
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: { note: "" },
        mode: 'onChange',
    });

    const handleClickOpen = () => {
        setOpen(true);
        setErrorMessage("");
    };

    const handleClose = () => {
        setOpen(false);
        reset({ note: "" });
    };

    const handleSendApproval = async (data) => {
        try {
            const payload = {
                report_or_inspection_uuid: report_or_inspection_uuid,
                note: data.note,
                status: false,
                user_uuid: currentUser.id,
                report_uuid: report_uuid
            };
            // 第一報
            if (type === "initial") {
                await postData("api/post_first_approval_remand", payload);
                window.location.href = `/first_report/${earthquake_uuid}`;
                // 1次点検
            } else if (type === "primary") {
                await postData("api/post_primary_approval_remand", payload);
                window.location.href = `/primary_inspection/${earthquake_uuid}`;
                // 2次点検
            } else {
                await postData("api/post_secondary_approval_remand", payload);
                window.location.href = `/secondary_inspection/${earthquake_uuid}`;
            }
        } catch (error) {
            console.error("承認に失敗しました:", error);
            setErrorMessage("承認に失敗しました。もう一度お試しください。");
        }
        setOpen(false);
    };

    return (
        <>
            <BoxSpaceCenter>
                <RejectAprovalButton startIcon={<CancelIcon />} onClick={handleClickOpen}>
                    差し戻し
                </RejectAprovalButton>
                <InputDialog
                    open={open}
                    onClose={handleClose}
                    title="差し戻し"
                    message={"報告書の記載内容について差し戻しを行います。\nよろしいですか？"}
                    onConfirm={handleSubmit(handleSendApproval)}
                    confirmText='OK'
                    cancelText='キャンセル'
                    errors={errors}
                    label={"差し戻し理由を記載してください"}
                    registerProps={
                        {
                            ...register("note", {
                                onBlur: () => trigger('note')
                            })
                        }}
                />
            </BoxSpaceCenter>
        </>
    );
}
